import React from 'react';

/**
 * AccessDenied component - Shows a friendly access denied message
 * @param {string} resource - The resource name (e.g., "notes", "medications")
 * @param {string} action - The action being denied (e.g., "view", "add", "edit")
 */
function AccessDenied({ resource = "this resource", action = "access" }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <div className="bg-red-50 border-2 border-red-200 rounded-lg p-8 max-w-md text-center">
        <svg 
          className="w-16 h-16 text-red-400 mx-auto mb-4" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" 
          />
        </svg>
        <h3 className="text-xl font-semibold text-red-800 mb-2">
          Access Denied
        </h3>
        <p className="text-red-600 mb-4">
          You don't have permission to {action} {resource}.
        </p>
        <p className="text-sm text-red-500">
          Please contact your administrator if you believe this is an error.
        </p>
      </div>
    </div>
  );
}

export default AccessDenied;